import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from './api/axiosInstance';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const Profile = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [error, setError] = useState('');

  const location = useLocation();
  const id = new URLSearchParams(location.search).get('id');

  useEffect(() => {
    if (!id) { setError('No user ID provided'); return; }
    api.get(`${base_url}/api/user/getApplicationDetailsById`, { params: { id } })
      .then(res => setUserDetails(res.data))
      .catch(() => setError('Error fetching profile data'));
  }, [id]);

  const fields = userDetails ? [
    { label: 'Name', value: userDetails.name },
    { label: 'Mobile Number', value: userDetails.mobileNo },
    { label: 'Email', value: userDetails.emailId },
    { label: 'Date of Birth', value: userDetails.dob },
    { label: 'Father Name', value: userDetails.fatherName },
    { label: 'Aadhaar Number', value: userDetails.aadharNumber },
    { label: 'PAN Number', value: userDetails.panNo },
    { label: 'Purpose of Loan', value: userDetails.purposeOfLoan },
  ] : [];

  return (
    <div className="app-page">
      <TopBar title="My Profile" backPath={`/CustomerEmiPage?id=${id}`} />

      <div className="app-content">
        {error ? (
          <div className="app-card" style={{ color: '#e53935', textAlign: 'center' }}>{error}</div>
        ) : !userDetails ? (
          <div className="app-card" style={{ textAlign: 'center', color: '#888' }}>Loading...</div>
        ) : (
          <div className="app-card">
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#1d2e77', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', fontSize: 28, color: '#fff', fontWeight: 700 }}>
                {(userDetails.name || 'U')[0].toUpperCase()}
              </div>
              <p style={{ fontSize: 18, fontWeight: 700, color: '#1d2e77' }}>{userDetails.name}</p>
            </div>

            {fields.map((f, i) => f.value ? (
              <div key={i} className="info-row">
                <span>{f.label}</span>
                <strong>{f.value}</strong>
              </div>
            ) : null)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
